module.exports = __webpack_public_path__ + "img/stroke-arrow.0cf65bbb.svg";